import { Link } from 'react-router-dom';
import '../../styles/home-specialty.css';
import {
  FaArrowRight,
  FaChartLine,
  FaDatabase,
  FaGraduationCap,
  FaSearch,
  FaShieldAlt,
  FaShoppingCart,
  FaTags,
  FaWpforms,
} from 'react-icons/fa';
import { HOME_SPECIALTY_COMPACT } from '../../data/homepageSeoReview';

const SPECIALTY_ICONS = {
  education: FaGraduationCap,
  'forms-crm': FaWpforms,
  'education-search': FaSearch,
  'woocommerce-payments': FaShoppingCart,
  'analytics-tags': FaChartLine,
  'privacy-widgets': FaShieldAlt,
  cataloging: FaTags,
};

/**
 * Lightweight homepage band for niche services — links to full landing pages.
 */
export default function HomeSpecialtyCompact() {
  return (
    <section className="home-specialty-compact home-surface--dark" aria-labelledby="home-specialty-compact-heading">
      <div className="home-specialty-compact__orb home-specialty-compact__orb--left" aria-hidden="true" />
      <div className="home-specialty-compact__orb home-specialty-compact__orb--right" aria-hidden="true" />
      <div className="home-specialty-compact__shell">
        <div className="home-specialty-compact__header">
          <div>
            <p className="home-focus-section__kicker">Specialized delivery</p>
            <h2 id="home-specialty-compact-heading" className="h2 heading-title">
              Focused integration pages for the systems buyers search for
            </h2>
            <p className="heading-text">
              Upgraded from one short block into dedicated service paths for education platforms, forms and CRM,
              search, WooCommerce payments, analytics, privacy widgets, and cataloging.
            </p>
          </div>
          <div className="home-specialty-compact__signal" aria-label="Delivery direction">
            <span>Audit</span>
            <FaArrowRight aria-hidden="true" />
            <span>Integrate</span>
            <FaArrowRight aria-hidden="true" />
            <span>Rank</span>
          </div>
        </div>

        <div className="home-specialty-compact__flow" aria-label="Specialized delivery page flow">
          {HOME_SPECIALTY_COMPACT.map((item, index) => {
            const Icon = SPECIALTY_ICONS[item.id] || FaDatabase;
            return (
              <Link to={item.to} className="home-specialty-compact__flow-node" key={item.id}>
                <span className="home-specialty-compact__flow-icon">
                  <Icon aria-hidden="true" />
                </span>
                <span>{item.title}</span>
                {index < HOME_SPECIALTY_COMPACT.length - 1 ? (
                  <FaArrowRight className="home-specialty-compact__flow-arrow" aria-hidden="true" />
                ) : null}
              </Link>
            );
          })}
        </div>

        <div className="home-specialty-compact__grid">
          {HOME_SPECIALTY_COMPACT.map((item, index) => {
            const Icon = SPECIALTY_ICONS[item.id] || FaDatabase;
            return (
              <article
                key={item.id}
                className={`home-specialty-compact__card home-specialty-compact__card--${item.tone}`}
              >
              <div className="home-specialty-compact__card-top">
                <span className="home-specialty-compact__card-icon">
                  <Icon aria-hidden="true" />
                </span>
                <span className="home-specialty-compact__card-step">
                  {String(index + 1).padStart(2, '0')}
                </span>
              </div>
              <p className="home-specialty-compact__eyebrow">{item.eyebrow}</p>
              <h3>{item.title}</h3>
              <p className="home-specialty-compact__summary">{item.summary}</p>
              <ul className="home-specialty-compact__bullets">
                {item.bullets.map((bullet) => (
                  <li key={bullet}>{bullet}</li>
                ))}
              </ul>
              <div className="home-specialty-compact__integrations" aria-label={`${item.title} third-party experience`}>
                <span className="home-specialty-compact__integrations-label">Third-party stack</span>
                <ul>
                  {item.integrations.map((integration) => (
                    <li key={integration}>{integration}</li>
                  ))}
                </ul>
              </div>
              <Link to={item.to} className="home-focus-card__link">
                {item.cta} <FaArrowRight aria-hidden="true" />
              </Link>
            </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
